import React from "react";
import { FolderSearch } from "lucide-react";

interface RepositoryEmptyStateProps {
  isFiltered: boolean;
}

const RepositoryEmptyState = ({ isFiltered }: RepositoryEmptyStateProps) => {
  return (
    <div className="flex min-h-[220px] flex-col items-center justify-center gap-2 rounded-md border border-dashed text-center">
      <FolderSearch className="h-5 w-5 text-muted-foreground" />
      <p className="text-sm font-medium">
        {isFiltered ? "No repositories match current filters" : "No repositories available"}
      </p>
      <p className="max-w-md text-xs text-muted-foreground">
        {isFiltered
          ? "Try clearing search, selecting another owner, or switching from favorites to all."
          : "Check GitHub app permissions or refresh the repository list."}
      </p>
    </div>
  );
};

export default RepositoryEmptyState;
